import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sexual-offenses',
  templateUrl: './sexual-offenses.component.html',
  styleUrls: ['./sexual-offenses.component.css']
})
export class SexualOffensesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
